import { render, staticRenderFns } from "./changeSign.vue?vue&type=template&id=680e951a&scoped=true&"
import script from "./changeSign.vue?vue&type=script&lang=js&"
export * from "./changeSign.vue?vue&type=script&lang=js&"
import style0 from "./changeSign.vue?vue&type=style&index=0&id=680e951a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e951a",
  null
  
)

export default component.exports